import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { SimChartAssignment } from 'models/ui';
import { DATE_FORMAT_MAR } from 'constants/app.constant';
import { compose } from 'redux';
import { studentSelectors } from 'redux/ducks/student';
import { Box } from 'components/common';
import { ELSButton, ELSCheckBox, ELSIcon } from 'components/common/els';
import DrugNameBtnRedirect from './DrugNameBtnRedirect';
import { MarAdministerFormField } from './MarAdministerSidebar';
import MarAdministerTextbox from './MarAdministerTextbox';

interface MarAdministerItemProps {
  formFieldItem: MarAdministerFormField;
  fullAssignment: SimChartAssignment;
  isSingle: boolean;
  checkboxHandler?: Function;
  onChange: Function;
  onBlur?: Function;
  onSkipBarcode?: Function;
}

const MarAdministerItem = ({ checkboxHandler, formFieldItem, onChange, onBlur, onSkipBarcode, fullAssignment, isSingle }: MarAdministerItemProps) => {
  const isAfterToday = moment(formFieldItem.dosageTimeTable).isAfter(moment(), 'day');
  const dosageDateTime = `${moment(formFieldItem?.dosageTimeTable).format(DATE_FORMAT_MAR)} | ${formFieldItem?.dosageTimeSeparate || '00:00'} | ${moment(
    formFieldItem?.dosageTimeTable
  ).format('dddd')}`;
  return (
    <Box className="mar-administer-sidebar__container">
      {isAfterToday && (
        <div className="mar-administer-sidebar__container__info-message">
          <ELSIcon name="confirmation-outline-circle" size="1x" color="link-inline" customClass="info-message-icon" />
          <span className="info-message-text">You are administering this medication earlier than planned.</span>
        </div>
      )}
      <div className="mar-administer-sidebar__container__info">
        <div className="mar-administer-sidebar__container__info__checkbox">
          {!isSingle && <ELSCheckBox checked={formFieldItem.checked} changeHandler={() => checkboxHandler(formFieldItem)} />}
          <DrugNameBtnRedirect drugName={formFieldItem?.drugName} showLink />
        </div>
        <div className="mar-administer-sidebar__container__info__text">
          <div className="mar-administer-sidebar__container__info__text__details">{`${formFieldItem?.route} · ${formFieldItem?.dose} · ${formFieldItem?.frequency}`}</div>
          <div className="mar-administer-sidebar__container__info__text__more">{formFieldItem?.specialInstructions}</div>
          <div className="mar-administer-sidebar__container__info__text__time">{`Dosage Date & Time: ${dosageDateTime}`}</div>
        </div>
      </div>
      <div className="mar-administer-sidebar__container__actions">
        {fullAssignment?.barcodeEnabled && (
          <>
            <MarAdministerTextbox formFieldItem={formFieldItem} onChange={onChange} onBlur={onBlur} isDisabled={formFieldItem.skipBarCode} showCheckmark />
            <ELSButton type="debuttonize" text={formFieldItem.skipBarCode ? 'Include Barcode' : 'Skip Barcode'} className="skip-btn" onClick={() => onSkipBarcode(formFieldItem)} />
          </>
        )}
      </div>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  fullAssignment: studentSelectors.getFullAssignment(state)
});

export default compose(connect(mapStateToProps))(MarAdministerItem);
